import { render, staticRenderFns } from "./LogCustomerContact.vue?vue&type=template&id=b0ae760c"
import script from "./LogCustomerContact.vue?vue&type=script&lang=js"
export * from "./LogCustomerContact.vue?vue&type=script&lang=js"
import style0 from "./LogCustomerContact.vue?vue&type=style&index=0&id=b0ae760c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports